import React, { useState, useEffect, useRef } from 'react';
import {urlBase} from "../../config/Globals";

import loupe from "../../assets/images/loupe.svg";
import picto_carte from "../../assets/images/picto-carte.svg";
import CommuneService from "../../service/CommuneSevice";
import iconSearch from "../../assets/images/search-commune.svg";
import {DownloadModalComponent} from "../ModalProspection";



export const RechercheIntro = ({openDownloadModal}) => {

    const [inputValue, setInputValue] = useState('');
    const [isOpen, setIsOpen] = useState(false);
    const searchContainerRef = useRef(null);


    //trouver la commune
    const[communes, setCommunes] = useState([]);
    const[loadingCommunes, setLoadingCommunes] = useState(1);
    const searcCommune = async(txt) => {
        try {
            const data = await CommuneService.search(txt);
            setCommunes(data.rows);
            setLoadingCommunes(false);
        } catch (error) {

        }
    }
    const handleInputChange = (e) => {
        const value = e.target.value;
        //console.log(value);
        setInputValue(value);

        if (value.trim().length >= 3) {
            //rechercher
            searcCommune(value.trim());
            setIsOpen(true);
        } else {
            setIsOpen(false);
        }
    };
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (searchContainerRef.current && !searchContainerRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        document.addEventListener('click', handleClickOutside);
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, []);

    return (
        <>
            <div
                className="w-100 position-fixed z-3 bottom-0 start-0 pb-xl-3 pb-xxl-4 sticky-search-bar d-none d-md-block">
                <div className="container position-relative">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-12 col-xl-10 d-flex gap-3 bg-marron px-3 py-4 alig-items-center">
                            <div className="position-absolute top-0 end-0 h-100 w-50 d-none d-md-block" style={{
                                background: `url(${iconSearch}) right 5rem center/contain no-repeat`,
                                opacity: 0.25,
                                backgroundSize: '250px 250px',
                                pointerEvents: 'none'
                            }}></div>
                            <div className="col-1 d-none d-lg-flex justify-content-center align-items-center p-3">
                                <img className="col-12 img-fluid" src={picto_carte} alt="Picto carte"/>
                            </div>
                            <div className="col-12 col-xl-11 d-flex flex-column">
                                <span className="lead fs-4 lh-normal text-white fw-b pb-3">Carte des zones de traitement, calendrier de prospection, résultats</span>
                                <div className="d-flex flex-grow-1 align-items-center gap-3">
                                    <div className="col-12 col-lg-5 col-xxl-6">

                                        <div ref={searchContainerRef} className="input-group position-relative">
                                            {isOpen && (
                                                <div id="search-results-box"
                                                     className="search-results-dropdown position-absolute bottom-100 start-0 w-100 p-3 shadow">
                                                    <ul className="list-unstyled mb-0 d-flex flex-column gap-1">
                                                        {communes && communes.length > 0 ? (
                                                            communes.map((commune) => (
                                                                <li key={commune.id}>
                                                                    <a href={urlBase + "calendrier-prospection/" + commune.id}
                                                                       className="search-result-item d-block text-decoration-none text-dark">

                                                                    <span
                                                                        className="fw-bold">{commune.nom} ({commune.numero_departement})</span>
                                                                        {commune.secteurs.length > 1 && (
                                                                            <span
                                                                                className="text-muted small"> ({commune.secteurs.length} secteurs)</span>
                                                                        )}
                                                                        {commune.secteurs.length > 1 && commune.secteurs.map((secteur) => (
                                                                            <span key={secteur.id || secteur.nom}
                                                                                  className="d-block fst-italic text-secondary small">
                                                                            • {secteur.nom}
                                                                        </span>
                                                                        ))}
                                                                    </a>
                                                                </li>
                                                            ))
                                                        ) : (
                                                            <li>Aucun résultat</li>
                                                        )}
                                                    </ul>
                                                </div>
                                            )}
                                            <input
                                                type="text"
                                                id="commune-search-input"
                                                className="form-control rounded-pill ps-4 py-2 border-0"
                                                placeholder="Rechercher une commune"
                                                aria-label="Rechercher une commune"
                                                value={inputValue}
                                                onChange={handleInputChange}
                                            />
                                            <span
                                                className="input-group-text bg-white border-0 rounded-pill position-absolute end-0 top-50 translate-middle-y me-2 p-1"
                                                style={{zIndex: 5, cursor: 'pointer'}}>
                                            <img src={loupe} alt="Rechercher"/>
                                        </span>
                                        </div>
                                    </div>
                                    <div className="d-none d-lg-block text-white small">
                                        ou&nbsp;
                                        <a className="btn btn-warning py-2 position-relative z-1" role="button" onClick={openDownloadModal}>Télécharger les plannings et résultats</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}